import { connect } from 'react-redux'
import { Props } from './Abort'
import { startAbort } from '../../redux/actions/app/abort.actions'

const mapDispatchToProps: Pick<Props, 'startAbort'> = {
    startAbort,
}

export default connect(undefined, mapDispatchToProps)
